var map = {
	"./content-features/content-html.svg": "7d72",
	"./content-features/content-not-form.svg": "7d61",
	"./content-features/content-pic.svg": "4b13",
	"./content-features/content-slide.svg": "a0e2",
	"./content-features/content-url.svg": "157e",
	"./content-features/content-video.svg": "0571",
	"./faq.svg": "4d2c",
	"./key_1.svg": "cc33",
	"./key_2.svg": "b36f",
	"./key_3.svg": "ffae",
	"./manage-advantages/RKEY_1.svg": "5276",
	"./manage-advantages/RKEY_2.svg": "dc34",
	"./manage-advantages/RKEY_3.svg": "e7da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9321";